$(document).ready(function() {
    $("#registrationForm").validate();
    $('#registrationForm').on('submit', function(e) {
        e.preventDefault(); // Prevent the form from submitting the traditional way

        // Check password match
        
        var button = $(this);
        /*var password = $('#password').val();
        var confirmPassword = $('#confirm_password').val();
        var passwordError = $('#passwordError');
        if (password !== confirmPassword) {
            passwordError.html($('<div />').addClass('message error').text('Passwords do not match!'));
            return;
        } else {
            passwordError.text('');
        }*/

        // Send form data via AJAX
        if (!$("#registrationForm").valid()) {
            return false;
        }
        $.ajax({
            url: $('#registrationForm').attr('action'), // Replace with your server endpoint
            type: 'POST',
            contentType: "application/x-www-form-urlencoded",
            dataType: "json",
            crossDomain: true,
            data: $(this).serialize(),
            beforeSend: function() {
              $('#responseMessage').html('');
              button.attr('disabled','disabled');
              $("#page-loader").addClass('show');
            },
            success: function(response) {
              // Handle success response
              $('#responseMessage').html('');
              $('#responseMessage').html($('<div />').addClass('message success').text('Application received.'));
              $('#registrationForm')[0].reset(); // Reset form fields
            },
            error: function(xhr, status, error) {
                $('#responseMessage').html('');
                var errMsgs = [];
                errMsgs.push('Registration failed. Please try again.');
                if (xhr?.responseJSON?.errors) {
                  Object.keys(xhr.responseJSON.errors).forEach((errKey) => {
                    var errmsg = xhr.responseJSON.errors[errKey];
                    errMsgs.push(Array.isArray(errmsg) ? errmsg.join(" ") : errmsg);
                  })
                }
                $('#responseMessage').append($('<div />').addClass('message error').html(errMsgs.join(" ")));
            },
            complete: function(){
                  $("#page-loader").removeClass('show');
            }
        });
    });
  
    $('#delivery_same_as_invoice').on('change',function () {
        if ($(this).is(':checked')) {
          $('[data-delivery-address]').hide();
        } else {
          $('[data-delivery-address]').show();
        }
    });
    $('#registered_same_as_invoice').on('change',function () {
        if ($(this).is(':checked')) {
          $('[data-registered-address]').hide();
        } else {
          $('[data-registered-address]').show();
        }
    });
});